import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hayfever-oem-register-message',
  templateUrl: './hayfever-oem-register-message.component.html',
  styleUrls: [
    './hayfever-oem-register-message.component.css',
    '../style/global.css',
  ],
})
export class HayfeverOemRegisterMessageComponent implements OnChanges {
  pref: string;
  @Input()
  clientId: string;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.clientId);

    this.pref = environment.apps[this.clientId].oemConfig?.pref;
  }

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }
}
